import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                     from '@ngx-translate/core';

import { CompanyService }                       from '../companies/company.service';
import { IntegrationQuotePricesModel }          from '../integrations/typings/integration.quote-prices';
import { MessagesService }                      from '../messages/messages.service';
import { VehicleRegistrationRequestQuoteModel } from './typings/vehicle-registration.request-quote';
import { VehicleRegistrationService }           from './vehicle-registration.service';

@Component({
  selector   : 'wor-vehicle-registration-purchase',
  template: require('./vehicle-registration.purchase.component.html')
})
export class VehicleRegistrationPurchaseComponent {
  @BlockUI('vehicleRegistrationPurchaseBlock') block : NgBlockUI;

  @Input() prices: IntegrationQuotePricesModel;

  quote: VehicleRegistrationRequestQuoteModel = {
    agree   : false,
    price   : '0.00',
    quantity: 0,
    total   : '0.00'
  };

  constructor (
    public  activeModal               : NgbActiveModal,
    public  companyService            : CompanyService,
    private messagesService           : MessagesService,
    private translateService          : TranslateService,
    @Inject(forwardRef(() => VehicleRegistrationService))
    private vehicleRegistrationService: VehicleRegistrationService
  ) {}

  confirm () : void {
    this.block.start();

    this.vehicleRegistrationService.confirmPurchase(this.quote)
    .then(() => {
      this.activeModal.close();

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PURCHASE_SUCCESSFUL'), 'success');
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  getCurrentPrice () : string {
    return this.vehicleRegistrationService.getCurrentPrice(this.quote.quantity, this.prices);
  }

  updateTotal () : void {
    this.quote.price = this.getCurrentPrice();

    this.vehicleRegistrationService.getQuote(this.quote)
    .then(( quote : VehicleRegistrationRequestQuoteModel ) => {
      this.quote = quote;
    })
    .catch(error => this.messagesService.error(error));
  }
}
